import { defineComponent, computed } from '@vue/composition-api';
export default defineComponent({
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    btnName: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props) {
    var descArr = computed(function () {
      return Array.isArray(props.desc) ? props.desc : [props.desc];
    });
    return {
      descArr: descArr
    };
  }
});